/**
 * Moves the theme's referral heading and text into the Yotpo widget's copy
 * column, so it sits beside the photo instead of above the whole widget:
 * above the Join / Login buttons when logged out (.yotpo-customer-login-view),
 * above the copy-link field when logged in (.yotpo-email-view). Yotpo's own title and description are hidden by CSS
 * (.ylty-referral--custom-copy) whenever theme copy is set.
 */
(() => {
  const blocks = document.querySelectorAll('[data-ylty-referral-copy]');
  if (!blocks.length) return;

  blocks.forEach((copy) => {
    const section = copy.closest('.ylty-referral');
    if (!section) return;

    const place = () => {
      const view = section.querySelector('.yotpo-customer-login-view, .yotpo-email-view');
      if (!view) return;
      // Bail when already first in the column: re-inserting retriggers the observer.
      if (copy.parentElement === view && view.firstElementChild === copy) return;
      view.insertBefore(copy, view.firstElementChild);
    };

    // At most one move per animation frame: the copy lives inside Yotpo's Vue
    // markup, and if Vue re-renders around it we must not spin in lockstep.
    let queued = false;
    const schedule = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        place();
      });
    };

    place();
    const observer = new MutationObserver(schedule);
    observer.observe(section, { childList: true, subtree: true });
    // Yotpo may never render (blocked script) — stop watching.
    setTimeout(() => observer.disconnect(), 15000);
  });
})();
